<template>
        <div class="wrapper">
       <!-- <article class="title">
        <h1 class="hi">Samsung-EcoPackage Privacy Notice </h1>
        <p>Effective Date: March 27, 2020</p>
        <p>Samsung Electronics Co., Ltd., along with our affiliates and subsidiaries (collectively, “Samsung”) respect your concerns about privacy. This Samsung-EcoPackage Privacy Notice applies to the personal information we collect through the Samsung-EcoPackage services (“SEP”). It does not apply to information collected by other apps, websites or services provided by Samsung. Samsung is the data controller for the processing of personal data.</p>
        <p>This Privacy Notice provides information about how Samsung collects, uses and shares your personal information in connection with SEP. Our Privacy Policy at <a class="link" href="https://account.samsung.com/membership/pp">https://account.samsung.com/membership/pp</a> (“Samsung Privacy Policy”) will also apply to your use of SEP, and should be read in conjunction with this Privacy Notice. The Samsung Privacy Policy provides additional information about our personal information practices, including how to contact us. In the event any portion of this Privacy Notice conflicts with the Samsung Privacy Policy, the relevant provisions of this Privacy Notice will apply.</p>
        </article>

        <ol class ="info-list">
          <li class="info-item-0">
            <h2>WHAT INFORMATION DO WE COLLECT?</h2>
            <p>Through SEP, we obtain and maintain information about you in various ways. </p>
            <h3>Information You Provide Directly</h3>
            <p>SEP collects information from you directly. For example:</p>            
            <p>• When you communicate with our Customer Service staff or others, your communications will be transmitted through our systems.</p>
            <h3>Information About Your Use of SEP</h3>
            <p>In addition to the information you provide, we will collect information about your use of our SEP through software on your devices and by other means. We will collect: </p>
            <ol class="one-depth">
                <li>
                    <ul class="one-depth">
                      <li> • Device information: Your hardware model, device hardware information, IMEI number and other unique device identifiers, phone number, serial number, sales code, access recording, current software version, MCC (Mobile Country Code), MNC (Mobile Network Code), MAC address, IP address, cookies, pixels, subscription information, operating system versions, and settings of the devices you use to access SEP.</li>
                      <li> • Log information: Diagnostic, technical, error, and usage information such as the time and duration of your use of SEP, search query terms when you enter search terms into your device in connection with SEP, and any information stored in cookies that we have set on your devices.</li>
                      <li> • Location information: Your device’s GPS signal or information about nearby Wi-Fi access points and cell towers that may be transmitted to us when you use SEP and enable the Location function.</li>
                      <li> • Other information about your use of SEP, such as the apps you use, the websites you visit, and how you interact with content offered through SEP.</li>
                    </ul>
                </li>
             </ol>        
            </li>
          <li class="info-item-1">
             <h2>HOW DO WE USE YOUR INFORMATION?</h2>
             <p>We use the information we collect for the following purposes:</p>
             <ol class="one-depth">
                <li>
                    <ul class="one-depth">
                      <li> • To provide customized advertising, promotions and offers that might interest you on our websites, third-party websites, and online platforms such as social media sites</li>
                      <li> • To analyze our products and services to help us better understand our customers in order to offer the most relevant communications, services and experiences to you</li>
                      <li> • To comply with the law and legal processes</li>
                      <li> • To protect the rights, property, or safety of Samsung Electronics, or any of our affiliates, business partners, or customers</li>
                    </ul>
                </li>
             </ol> 
             <p>We use and combine the information we collect about you from SEP with data from other services or features you use, your devices including your Samsung SMART TV if you have one, customer services, purchases made from our website and other sources to provide you with a better experience. For example, you can use your Samsung account details not only on Samsung services or features you have registered with, but also with other services or features which use Samsung accounts. We also use the information you provide directly or through other sources as described above to provide content you may like or that has been personalized. </p>       
             <p>Samsung processes personal information for the purposes described above. Samsung’s legal basis to process personal information includes processing: </p>
              <ol class="one-depth">
                <li>
                    <ul class="one-depth">
                      <li> (i) So that we can keep our promises to you, such as providing you with SEP;</li>
                      <li> (ii) To promote our business interests (for example, to manage our relationship with you and improve your customer service experience), including communications on our website, third party websites, and online platforms;</li>
                      <li> (iii) To comply with the law and legal processes; and</li>
                      <li> (iv) With your consent (for example, to send direct marketing communications). If you give consent, you can always revoke by contacting us as specified in the CONTACT US section of the Samsung Privacy Policy.</li>
                    </ul>
                </li>
             </ol> 
          </li>
          <li class="info-item-2">
             <h2>HOW LONG DO WE RETAIN YOUR INFORMATION AND WHERE DOES IT GO?</h2>
              <p>We will not keep your personal data for longer than is necessary for the purpose for which it was collected. This means that information will be destroyed or erased from our systems when it is no longer required. We retain the following types of data about you according to the table below:</p>
                <table class="type-wide">
                <tbody>
                  <tr>
                    <th class>Data type</th>
                    <th class>Retention period</th>
                    <th class> Destruction period/process</th>
                  </tr>
                  <tr>
                    <td class>Device information: Your hardware model, device hardware information, IMEI number and other unique device identifiers, phone number, serial number, sales code, access recording, current software version, MCC (Mobile Country Code), MNC (Mobile Network Code), MAC address, IP address, cookies, pixels, subscription information, operating system versions, and settings of the devices you use to access SEP.</td>
                    <td class>(i) Upon user’s request for deletion, or (ii) deletion of Samsung Account, whichever comes first</td>
                    <td class>Subject to applicable law, deleted immediately upon the expiry of the retention period </td>
                  </tr>
                </tbody>
                </table>
                <p>Your use of SEP will involve the transfer, storage, and processing of your personal information to other countries; such countries include, without limitation, countries in the European Economic Area, [MORE COUNTRY NAMES AS APPLICABLE].</p>
          </li>
          <li class="info-item-3">
            <h2>UPDATES TO THIS PRIVACY NOTICE</h2>
            <p>This Privacy Notice may be updated periodically to reflect changes in our personal information practices with respect to SEP or changes in the applicable law. We will indicate at the top of this Privacy Notice when it was most recently updated.</p>
          </li>
        </ol> -->
        </div>
</template>

<script>


export default {
  components: {
  },
  data() {
    return {
     };
  },
  created() {
   this.$router.push({ name: 'Home' });

  },
  methods: {

  }
};
</script>

<style scoped>
.wrapper {
  background-color: black;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
    margin:auto;
}
.link{
    cursor: pointer;
}
/* .p{
  margin-block-start:1em;
  margin-block-end:1em;
} */
.hi{
  margin-top: 128px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
/* li{
  margin-top:4.453125vw;
} */
table{
  border-collapse:collapse;
  width:100%;
  text-align:center;
  margin-top:20px;
  margin-bottom:20px;

}
td,th{
  padding:0;
}
h3{
  margin-bottom:10px;
}
td,th{
  border: 1px solid #FFFFFF;
}
.info-item-0, .info-item-1,.info-item-2,.info-item-3,.info-item-4,.info-item-5,.info-item-6,.info-item-7,.info-item-8,.info-item-9,.info-item-10{
  margin-top:30px;
}
.info-item-2{
  margin-top:20px;
}
table.type-short{
  width:365px;
}
table.type-wide{
  width:920px;
}
ul,ol{
  list-style:none;
}
dl,ul,ol,dt,dd,blockquote,p,h1,h2,h4,h5,h6{
  padding:0;
  margin:0;
  text-align:left;
}
tbody{
  display:table-row-group;
  vertical-align:middle;
}
@media (max-width: 1024px) {
  .wrapper{
    max-width: 83.33vw;
    margin:auto;
  }
 .hi{
  margin-top: 70px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  /* position:relative; */
}
h3{
  margin-bottom:10px;
}
table.type-wide{
  max-width: 83.33vw;
}
table.type-short{
  max-width: 83.33vw;
}
table{
  margin-top:10px;
  margin-bottom:10px;
}
}
</style>


    
    
   
   
   
    
   